module.exports = __webpack_public_path__ + "assets/certificate_pdf/R Language Today_Silicon Stone Education_20181122.9b453160.pdf";